import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

export const mutation = gql`
  mutation UpdateSuperchargerTextSettings(
    $gameId: Int!
    $notificationSettings: JSON!
  ) {
    updateSuperchargerTextSettings(
      gameId: $gameId
      notificationSettings: $notificationSettings
    )
  }
`;

export function useUpdateSuperchargerTextSettingsMutation() {
  const [mutate, { loading, error }] = useMutation(mutation);

  const updateSuperchargerTextSettings = ({ gameId, notificationSettings }) =>
    mutate({ variables: { gameId, notificationSettings } });

  return { updateSuperchargerTextSettings, loading, error };
}
